import styled from "styled-components/macro"
import Color from "../../../constants/Color"

export const Container = styled.div`
  position: fixed;
  top: 0;
  width: 100%;
  height: 100vh;
  display: flex;
  flex-direction: column;
  background-color: rgba(0, 0, 0, 0.95);
  z-index: 999;
  transition: all 0.3s ease-in-out;
`

export const Header = styled.div`
  padding-left: 16px;
  width: 100%;
  height: 63px;
  display: flex;
  align-items: center;
  background: #fff;
  border-bottom: 1px solid ${Color.gray400};
  z-index: 222;
`

export const SearchContainer = styled.div`
  position: relative;
  width: 100%;
  height: 63px;
  display: flex;
  align-items: center;
  position: sticky;
  top: 0;

  & i {
    position: absolute;
    right: 16px;
    font-size: 22px;
    color: ${Color.gray600};
  }

  @media (min-width: 640px) {
    & i {
      font-size: 24px;
      right: 0px;
    }
  }

  @media (min-width: 1280px) {
    & i {
      font-size: 28px;
    }
  }
`

export const Input = styled.input`
  width: 100%;
  padding: 12px 16px;
  font-size: 18px;
  font-weight: 500;
  letter-spacing: -0.3px;
  color: ${Color.gray600};
  border: none;
  outline: none;

  @media (min-width: 640px) {
    padding-left: 0;
  }

  @media (min-width: 1280px) {
    font-size: 22px;
  }
`

export const Result = styled.div`
  width: 100%;
  height: auto;
  overflow-y: scroll;
  scroll-behavior: smooth;
  border-color: ${Color.primary};
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
  filter: drop-shadow(0px 24px 32px rgba(0, 0, 0, 0.04)) drop-shadow(0px 16px 24px rgba(0, 0, 0, 0.04)) drop-shadow(0px 4px 8px rgba(0, 0, 0, 0.04)) drop-shadow(0px 0px 1px rgba(0, 0, 0, 0.04));

  @media (min-width: 640px) {
    padding: 18px 0;
  }
`

export const Headline = styled.h2`
  color: ${Color.gray100};
  margin-bottom: 12px;
  margin-left: 16px;

  @media (min-width: 640px) {
    margin-left: 0px;
  }

  @media (min-width: 1280px) {
    margin-bottom: 16px;
  }
`

export const Body = styled.div`
  padding: 12px 16px;
  width: 100%;
  height: 100%;
  display: grid;
  grid-template-columns: repeat(6, minmax(100px, 1fr));
  grid-gap: 16px;
  position: relative;

  @media (min-width: 640px) {
    padding: 6px 0px;
  }

  @media screen and (max-width: 1280px) {
    grid-template-columns: repeat(6, minmax(100px, 1fr));
  }

  @media screen and (max-width: 1024px) {
    grid-template-columns: repeat(4, minmax(100px, 1fr));
  }

  @media screen and (max-width: 768px) {
    grid-template-columns: repeat(3, minmax(100px, 1fr));
  }

  @media screen and (max-width: 600px) {
    grid-template-columns: repeat(2, minmax(100px, 1fr));
  }

  @media screen and (max-width: 375px) {
    grid-template-columns: repeat(0, 1fr);
  }

  @media (min-width: 1280px) {
    grid-gap: 32px;
  }
`

export const Card = styled.div`
  width: 100%;
  height: 238px;
  background: ${Color.gray400};
`

export const Select = styled.select`
  padding: 8px 6px;
  font-size: 14px;
  letter-spacing: 0.5px;
  text-transform: uppercase;
  color: ${Color.gray200};
  background: ${Color.gray800};
  outline: none;
  border: none;
  margin-right: 0px;
  border-radius: 4px;
  /* -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none; */

  & option {
    text-align: center;
  }

  @media (min-width: 640px) {
    margin-right: 12px;
  }
`

export const CardContainer = styled.div`
  text-decoration: none;
  color: ${Color.gray300};
`

export const Thumb = styled.div`
  position: relative;
  width: 156px;
  height: 216x;
  color: transparent;
  border-radius: 4px;
  border: 2px solid ridge;
  transition: all 0.3s ease-in-out;
  background: #f5f5f5;
  overflow: hidden;

  @media (min-width: 768px) {
    min-width: 160px;
    height: 216px;
  }

  @media (min-width: 1280px) {
    width: 180px;
    height: 270px;
  }

  &::before {
    content: "";
    position: absolute;
    top: 0;
    width: 100%;
    height: 100%;
    background: linear-gradient(205.89deg, rgba(0, 0, 0, 0) 49.81%, rgba(0, 0, 0, 0.8) 97.75%);
    z-index: 1;
  }
`

export const Image = styled.img`
  position: relative;
  width: 100%;
  height: 100%;
  object-fit: cover;
  transform: scale(1);
  transition: transform 0.3s ease-in-out;
  animation: fadeIn 1s;

  @keyframes fadeIn {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }
`

export const Rating = styled.div`
  display: flex;
  position: absolute;
  left: 8px;
  bottom: 10px;
  padding: 2px 6px;
  font-weight: 700;
  background: ${({ bg }) => (bg ? bg : "linear-gradient(270deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.24) 100%)")};
  color: ${({ color }) => color};
  border-radius: 3px;
  opacity: 0.9;
  z-index: 2;

  &i {
    margin-right: 4px;
  }
`

export const Info = styled.div`
  display: none;
  ${({ isTv }) => (isTv ? "display: block;" : "display: none;")}

  @media (min-width: 640px) {
    display: block;
    margin-top: 6px;
  }
`

export const Title = styled.h4`
  font-size: 16px;
  margin-bottom: 4px;

  @media (min-width: 640px) {
    width: 100%;
    font-size: 16px;
    font-weight: medium;
    margin-bottom: 4px;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }
`

export const Date = styled.p`
  font-size: 12px;
  color: ${Color.gray200};
  @media (min-width: 640px) {
    font-size: 14px;
  }
`
